import React from "react";
import { QuestionnaireStatus } from "../../constants/Constants";
import { usePromiseTracker } from 'react-promise-tracker';


export interface SubmitLinkProps {
    onSubmit: () => void;
    status: string;
}

export const SubmitLink = (props: SubmitLinkProps) => {

    const { status, onSubmit } = props;
    const { promiseInProgress } = usePromiseTracker();

    if (status === QuestionnaireStatus.Preview) {
        return null;
    }

    return (
        <a
            href="#!"
            className={`nav-link ${promiseInProgress ? "disable-submit" : ""}`}
            onClick={(e) => {
                e.preventDefault();
                onSubmit();
            }}
        >
            <span>Submit</span>
        </a>
    );
};